module.exports = __webpack_public_path__ + "static/img/evolução-percentuais.40e445a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolução-percentuais.png
// module id = C3OZ
// module chunks = 1